import { render, staticRenderFns } from "./ChatScheduleButtons.vue?vue&type=template&id=1732a4d7&scoped=true"
import script from "./ChatScheduleButtons.vue?vue&type=script&lang=js"
export * from "./ChatScheduleButtons.vue?vue&type=script&lang=js"
import style0 from "./ChatScheduleButtons.vue?vue&type=style&index=0&id=1732a4d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1732a4d7",
  null
  
)

export default component.exports